<template>
  <v-img
    v-bind="$attrs"
    v-on="$listeners"
    class="colored-svg-img"
  >
    <div
      v-if="svgContent"
      class="svg-wrapper"
      v-html="svgContent"
      :style="cssVars"
    />
  </v-img>
</template>

<script>
export default {
  name: 'ColoredSvgImg',

  props: {
    src: {
      type: String,
      required: true,
    },

    color1: {
      type: String,
      default: 'currentColor',
    },

    color2: {
      type: String,
      default: 'currentColor',
    },

    color3: {
      type: String,
      default: 'currentColor',
    },
  },

  data() {
    return {
      svgContent: null,
    }
  },

  computed: {
    cssVars() {
      return {
        '--svg-color-1': this.color1,
        '--svg-color-2': this.color2,
        '--svg-color-3': this.color3,
      }
    },
  },

  watch: {
    src: {
      immediate: true,
      handler() {
        this.loadSvg()
      },
    },
  },

  methods: {
    async loadSvg() {
      try {
        const response = await fetch(this.src)
        let svg = await response.text()

        svg = svg
          .replaceAll('fill="color-1"', `fill="${this.color1}"`)
          .replaceAll('fill="color-2"', `fill="${this.color2}"`)
          .replaceAll('fill="color-3"', `fill="${this.color3}"`)

        svg = svg
          .replaceAll('stroke="color-1"', `stroke="${this.color1}"`)
          .replaceAll('stroke="color-2"', `stroke="${this.color2}"`)
          .replaceAll('stroke="color-3"', `stroke="${this.color3}"`)

        this.svgContent = svg
      } catch (error) {
        this.svgContent = null
      }
    },
  },
}
</script>

<style scoped>
.colored-svg-img {
  display: flex;
  align-items: center;
  justify-content: center;
}

.svg-wrapper {
  width: 100%;
  height: 100%;
}

.svg-wrapper :deep(.color-1) {
  color: var(--svg-color-1);
}

.svg-wrapper :deep(.color-2) {
  color: var(--svg-color-2);
}

.svg-wrapper :deep(.color-3) {
  color: var(--svg-color-3);
}

.svg-wrapper :deep(.color-4) {
  color: var(--svg-color-4);
}

.svg-wrapper :deep(svg) {
  width: 100%;
  height: 100%;
}
</style>
